// extracted by mini-css-extract-plugin
export default {"display-none":"g__display-none--AYdRt","u-pointer-cursor":"g__u-pointer-cursor--MUEHF","header":"g__header--TsV7m"};